module.exports = __webpack_public_path__ + "media/images/restaurant/areas/western_honshu-c9b7911fb7e35829b62c7770fa294494.png";